import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";

import {
  CancelButton,
  PrimaryLoadingButton,
} from "../pages/css components/Button";
import Paper from "./Paper";

export default function ButtonFooter({
  ID = "",
  disabled = false,
  editState,
  setEditState,
  formikProps,
  route = "",
  deleteButton = [],
  path = "",
}) {
  const navigate = useNavigate();
  const [dialogState, setDialogState] = useState(false);

  const [deletePermission, handleDelete, buttonLabel = "Delete"] = deleteButton;

  if (!(deletePermission || (!!editState && !!setEditState && !!formikProps))) {
    return "";
  }

  return (
    <Paper>
      {!!deletePermission && !!ID && (
        <Grid item>
          <Button
            variant="contained"
            color="error"
            onClick={() => setDialogState(true)}
          >
            {buttonLabel}
          </Button>
        </Grid>
      )}

      <Grid item xs />

      {!editState && (
        <Grid item>
          <CancelButton
            variant="outlined"
            onClick={() => {
              if (editState && !!ID) {
                setEditState(!editState);
                formikProps.handleReset();
              } else {
                if (path) {
                  navigate(path);
                }
                if (!!route) {
                  navigate(-1, { state: route });
                }
                if (!path && !route) {
                  navigate(-1);
                }
              }
            }}
          >
            Back
          </CancelButton>
        </Grid>
      )}

      {!!editState && (
        <Grid item>
          <PrimaryLoadingButton
            type="submit"
            variant="contained"
            fullWidth
            onClick={formikProps.handleSubmit}
            disabled={!formikProps.dirty || !formikProps.isValid || disabled}
            loading={formikProps.isSubmitting}
            color="primary"
          >
            Submit
          </PrimaryLoadingButton>
        </Grid>
      )}

      {!!editState && (
        <Grid item>
          <CancelButton
            variant="outlined"
            disabled={formikProps.isSubmitting}
            onClick={() => {
              if (editState && !!ID) {
                setEditState(!editState);
                formikProps.handleReset();
              } else {
                if (path) {
                  navigate(path);
                }
                if (!!route) {
                  navigate(-1, { state: route });
                }
                if (!path && !route) {
                  navigate(-1);
                }
              }
            }}
          >
            {!!ID ? "Cancel" : "Back"}
          </CancelButton>
        </Grid>
      )}

      <DeleteDialog
        dialogState={dialogState}
        setDialogState={setDialogState}
        handleAgree={handleDelete}
      />
    </Paper>
  );
}

function DeleteDialog({ dialogState, setDialogState, handleAgree }) {
  return (
    <Dialog open={dialogState}>
      <DialogTitle style={{ paddingBottom: "4px" }}>Confirm Delete</DialogTitle>

      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete? This action cannot be reversed!
        </DialogContentText>
      </DialogContent>

      <DialogActions style={{ padding: "0px 24px 16px" }}>
        <Button
          onClick={() => {
            handleAgree();
            handleClose();
          }}
          variant="contained"
          color="error"
        >
          Delete
        </Button>

        <Button
          onClick={handleClose}
          variant="outlined"
          color="primary"
          autoFocus
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );

  function handleClose() {
    setDialogState(false);
  }
}
